import React from 'react';
import cn from 'classnames';
import styles from '../DropDown.module.scss';

export const DropDownItem = ({ label, onTextClick, isActive }) => {
  const isActiveItem = isActive ? styles.isActive : '';
  return (
    <>
      <div className={cn(styles.dropDown, isActiveItem)}>
        <div className={styles.dropDownBody} onClick={onTextClick}>
          <p>{label}</p>
        </div>
      </div>
    </>
  );
};
